var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChatMessageOutline = function SvgChatMessageOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 13a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2zM17 9a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2zM12 5a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20 0a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4h-2.9l-4.457 3.763a1 1 0 0 1-1.292 0L6.9 20H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4zM4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h2.9a2 2 0 0 1 1.293.473L12 21.69l3.809-3.217a2 2 0 0 1 1.29-.473H20a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z",
    clipRule: "evenodd"
  })));
};
export default SvgChatMessageOutline;